import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseSignalRService } from './base-signalr.service';

@Injectable({
  providedIn: 'root'
})
export class PendingSalesSignalRService extends BaseSignalRService {
  private readonly pendingSaleCompletedSubject = new BehaviorSubject<string>('');

  public pendingSaleCompleted$ = this.pendingSaleCompletedSubject.asObservable();

  protected getHubUrl(): string {
    return `${this.apiUrl}/pendingSalesHub`;
  }

  protected setupEventHandlers(): void {
    if (!this.hubConnection) {
      return;
    }

    this.hubConnection.on('PendingSaleCompleted', (opportunityId: string | { value: string; }) => {
      const id = typeof opportunityId === 'string' ? opportunityId : opportunityId.value;
      this.pendingSaleCompletedSubject.next(id);
    });

    this.setupConnectionStateHandlers();
  }
}
